"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdleSdk = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("./constants");
class IdleSdk {
    async getVaults() {
        const results = await axios_1.default.get(`${constants_1.baseUrl}pools`, {
            headers: { Authorization: `Bearer ${constants_1.apiKey}` },
        });
        if (results && results.data) {
            return results.data.filter((data) => data.externalIntegration);
        }
        return [];
    }
}
exports.IdleSdk = IdleSdk;
